import {
  LBAlertCircleIcon,
  LBSwitch,
  LBTooltip,
  LBTooltipContent,
  LBTooltipTrigger
} from '@linearb/buzz'

interface FeatureFlagOrgToggleProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  /** Why the flag can't be flipped here, from getOrgToggleBlockedReason. Null when it can. */
  blockedReason: string | null
  isAdmin: boolean
}

/**
 * The per-org feature flag switch, shared by the organizations list and the org
 * details settings section. A flag can be blocked by its lifecycle status;
 * admins may flip it anyway, but never silently.
 */
const FeatureFlagOrgToggle: React.FC<FeatureFlagOrgToggleProps> = ({
  checked,
  onCheckedChange,
  blockedReason,
  isAdmin
}) => {
  const switchElement = (
    <LBSwitch
      disabled={Boolean(blockedReason) && !isAdmin}
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
  )

  if (!blockedReason) {
    return switchElement
  }

  return (
    <LBTooltip>
      <LBTooltipTrigger asChild>
        {/* The switch is disabled for non-admins, so the wrapper carries the hover.
            tabIndex keeps the explanation reachable without a mouse — a disabled
            switch takes no focus of its own. */}
        <div tabIndex={0} className='flex w-fit items-center gap-2'>
          {switchElement}
          {isAdmin && (
            <LBAlertCircleIcon className='h-4 w-4 text-destructive' />
          )}
        </div>
      </LBTooltipTrigger>
      <LBTooltipContent>
        {isAdmin ? `Admin override: ${blockedReason}` : blockedReason}
      </LBTooltipContent>
    </LBTooltip>
  )
}

export default FeatureFlagOrgToggle
